import {
  durationToParts,
  formatDurationLabel,
  partsToDuration,
} from '../../../utils/rentalPeriod';
import './ProductDurationField.css';

export default function ProductDurationField({
  durationMinutes,
  onDurationMinutesChange,
  price,
}) {
  const parts = durationToParts(durationMinutes);
  const preview = formatDurationLabel(partsToDuration(parts.days, parts.hours, parts.minutes));
  const priceNumber = Number(String(price ?? '').replace(',', '.'));
  const priceText = Number.isFinite(priceNumber)
    ? `${priceNumber.toLocaleString('ru-RU')} сом`
    : 'цена';

  function update(next) {
    onDurationMinutesChange?.(partsToDuration(next.days, next.hours, next.minutes));
  }

  return (
    <section className="shop-create-section">
      <div className="shop-create-label">
        Длительность <b style={{ color: 'red' }}>*</b>
      </div>
      <div className="shop-create-help">
        {priceText} за {preview || '…'}. Например, 1 день — это 24 часа.
      </div>
      <div className="shop-duration-grid">
        <label>
          <span>Дни</span>
          <input
            className="shop-create-input"
            inputMode="numeric"
            value={parts.days || ''}
            placeholder="0"
            onChange={(event) => update({ ...parts, days: event.target.value })}
          />
        </label>
        <label>
          <span>Часы</span>
          <input
            className="shop-create-input"
            inputMode="numeric"
            value={parts.hours || ''}
            placeholder="0"
            onChange={(event) => update({ ...parts, hours: event.target.value })}
          />
        </label>
        <label>
          <span>Минуты</span>
          <input
            className="shop-create-input"
            inputMode="numeric"
            value={parts.minutes || ''}
            placeholder="0"
            onChange={(event) => update({ ...parts, minutes: event.target.value })}
          />
        </label>
      </div>
    </section>
  );
}
